var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 50,
    viewBox: "0 0 120 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 22L59.5528 18.7236C59.8343 18.5828 60.1657 18.5828 60.4472 18.7236L67 22",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 25,
    r: 23,
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 25,
    r: 23,
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22,
    width: 8,
    height: 6,
    rx: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 22,
    width: 8,
    height: 6,
    rx: 3,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da6aaa121aa8a3f8040051f33f523e1f.svg";
export { ForwardRef as ReactComponent };